/* Zevaraat: fireworks when the Shopify Forms popup opens. Self-contained, no dependencies. */
(function () {
  'use strict';
  if (window.__zevFwInit) return;
  window.__zevFwInit = true;

  var fired = false;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COLORS = ['#f5d77a', '#ffffff', '#e8b04b', '#ff6f91', '#7fdbff', '#c39bff'];

  function run(force) {
    if (reduce && !force) return;
    var c = document.createElement('canvas');
    c.setAttribute('aria-hidden', 'true');
    c.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483647;';
    document.body.appendChild(c);
    var ctx = c.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    function size() { c.width = innerWidth * dpr; c.height = innerHeight * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    size(); window.addEventListener('resize', size);

    var parts = [], start = performance.now(), DURATION = 2600, nextBurst = 0;
    function burst() {
      var x = innerWidth * (0.15 + Math.random() * 0.7), y = innerHeight * (0.12 + Math.random() * 0.4);
      var col = COLORS[(Math.random() * COLORS.length) | 0], n = 60 + ((Math.random() * 30) | 0);
      for (var i = 0; i < n; i++) {
        var a = (Math.PI * 2 * i) / n, s = 2 + Math.random() * 4;
        parts.push({ x: x, y: y, vx: Math.cos(a) * s, vy: Math.sin(a) * s, life: 1, decay: 0.012 + Math.random() * 0.012, col: Math.random() < 0.2 ? '#fff' : col });
      }
    }
    function frame(t) {
      var el = t - start;
      if (el < DURATION && el >= nextBurst) { burst(); nextBurst = el + 280 + Math.random() * 220; }
      ctx.clearRect(0, 0, innerWidth, innerHeight);
      ctx.globalCompositeOperation = 'lighter';
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i];
        p.vx *= 0.98; p.vy = p.vy * 0.98 + 0.06; p.x += p.vx; p.y += p.vy; p.life -= p.decay;
        if (p.life <= 0) { parts.splice(i, 1); continue; }
        ctx.globalAlpha = p.life; ctx.fillStyle = p.col;
        ctx.beginPath(); ctx.arc(p.x, p.y, 2.2, 0, Math.PI * 2); ctx.fill();
      }
      ctx.globalAlpha = 1;
      if (el < DURATION || parts.length) requestAnimationFrame(frame);
      else { window.removeEventListener('resize', size); c.remove(); }
    }
    requestAnimationFrame(frame);
  }

  function fireOnce() { if (fired) return; fired = true; window.__zevFwFired = true; cleanup(); run(false); }
  window.zevFireworks = function () { run(true); };

  /* ---- Popup detection ----
     Zevaraat's email popup is the theme's <promo-popup> custom element (assets/popup-newsletter.js),
     not Shopify Forms. PromoPopup.open() adds class "is-active" to .popup-container (display:none -> flex)
     and "newsletter-popup--open" to <body>. We hook open() directly and also watch the class change. */
  var DEBUG = /[?&]fwdebug=1/.test(location.search);
  function log() { if (DEBUG) console.debug.apply(console, ['[zevFireworks]'].concat([].slice.call(arguments))); }
  function trigger(why) { log('popup open detected via', why); fireOnce(); }

  var observers = [], poll = null, stopTimer = null;
  function cleanup() {
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
    if (poll) clearInterval(poll);
    if (stopTimer) clearTimeout(stopTimer);
  }

  // 1) Patch the custom element's open() method (most direct signal).
  function patchOpen() {
    var C = window.customElements && customElements.get('promo-popup');
    if (!C || C.prototype.__zevPatched) return;
    var orig = C.prototype.open;
    C.prototype.open = function () { var r = orig.apply(this, arguments); trigger('PromoPopup.open()'); return r; };
    C.prototype.__zevPatched = true;
    log('patched PromoPopup.prototype.open');
  }
  if (window.customElements) { patchOpen(); customElements.whenDefined('promo-popup').then(patchOpen); }

  // 2) Watch the newsletter popup's own container only (no generic dialogs/modals/lightboxes).
  function isOpen() {
    var pc = document.querySelector('promo-popup .popup-container.is-active');
    return pc ? 'promo-popup .popup-container.is-active' : null;
  }
  function check() { if (fired) return; var why = isOpen(); if (why) trigger(why); }

  function init() {
    log('init; promo-popup present:', !!document.querySelector('promo-popup'),
        'newsletter-popup cookie set (popup suppressed):', /(^|;)\s*newsletter-popup=/.test(document.cookie));
    var host = document.querySelector('promo-popup');
    if (!host) { log('no promo-popup on this page; only zevFireworks() available'); return; }
    var mo = new MutationObserver(check);
    mo.observe(host, { subtree: true, attributes: true, attributeFilter: ['class'] });
    observers.push(mo);
    poll = setInterval(check, 500);
    stopTimer = setTimeout(function () { log('stopped watching'); cleanup(); }, 120000);
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
